/* eslint-disable */
import 'react-app-polyfill/ie11';
import bootstrap from './bootstrap';
import PortalCustomerEntry from './Entries/PortalCustomer/PortalCustomer.entry';

bootstrap(PortalCustomerEntry);
